import find from 'lodash/find';
import i18n from '@/utils/i18n';
import { fromJS, List } from 'immutable';
import { cookiesToLocalStorage } from '@/utils/common';
import Cookies from 'js-cookie';
import store from '@/store';
import { isChecked, persistCheckedIds, persistLiveIds } from '@/views/sports/components/bet-slip/check-bets';
import { defaultRoundRobinTabContext } from '@/views/sports/store/bet-slip-store';
import snq from 'snq';

cookiesToLocalStorage();
const BETS_STORAGE_KEY = 'bets';
const SELECTIONS_STORAGE_KEY = 'selections';
const SELECTIONS_NEW_STORAGE_KEY = 'new_selections';
const SELECTIONS_NEW_BETSLIP_KEY = 'new_betslip';
const GAME_DETAILS_STORAGE_KEY = 'game_details';
const ROUND_ROBIN_STORAGE_KEY = 'ROUND_ROBIN_STORAGE_KEY';

// const BET_SLIP_DAYS = 1;

export function americanToDecimal(money_line) {
  if (money_line == 'EV' || money_line == 0) {
    money_line = 100;
  }
  var money_line_parsed = parseFloat(money_line);
  return decimalFromUS(money_line_parsed);
}

export function decimalFromUS(us) {
  if (us > 0) {
    return us / 100 + 1;
  } else {
    return (100 / us) * -1 + 1;
  }
}

export function roundAmount(amount) {
  return parseFloat(amount).toFixed(2);
}

export function createBet(
  type,
  betid,
  input_risk_amount,
  input_win_amount,
  use_free_play,
  open_spots,
  sub_type,
  checked,
) {
  return {
    type,
    betid,
    input_risk_amount: input_risk_amount || '',
    input_win_amount: input_win_amount || '',
    use_free_play,
    open_spots,
    sub_type,
    checked,
  };
}

// used for requesting /options and /confirmations requests
export function buildBets(state, sendZeros, getCheckeds = false, isGetBetOptions = false) {
  let selectedType = state.selectedType,
    betOption = state.betOptionsResponse,
    selections = state.newBetSlipSelection,
    roundRobinTab = state.roundRobinTab;

  const tmpBets = [];
  let filter = [];

  // if (getCheckeds) {
  //   bets = bets.filter(b => b.checked);
  // }

  if (selectedType == 'straight') {
    filter = ['straight'];

    if (selections.size >= 2) {
      filter.push('teaser');
      //filter.push("parlay");
      filter.push('round_robin');
    }
  } else if (selectedType == 'if_win' || selectedType == 'if_win_or_tie') {
    filter = ['if_win', 'if_win_or_tie'];
  } else {
    filter = [selectedType];
  }

  if (!isGetBetOptions && selectedType == 'round_robin') {
    //const straightSelections = selections.filter(s => isChecked(s.id)).toJSON();
    const straightSelections = JSON.stringify(selections);

    const useFreePlay = state.activeFreeBet ? 1 : 0;

    const straightBetRiskAmount = +roundRobinTab.straightBetRiskAmount;
    const roundRobinsAmounts = roundRobinTab.roundRobinsAmounts;
    if (straightBetRiskAmount > 0) {
      straightSelections.forEach(s => {
        const bet = createBet('straight', s.id, straightBetRiskAmount, 1, useFreePlay, 0, null, true);
        bet.free_wager_price_id = null;
        bet.selections = [s];
        tmpBets.push(bet);
      });
    }

    const availableTypes = snq(() => state.betOptionsResponse[0].options.available_types, []);

    const filled = Object.entries(roundRobinsAmounts)
      .filter(([key, _]) => !!availableTypes.find(p => p.parlay_size.toString() === key.toString()))
      .filter(([key, value]) => !!value);

    filled.forEach(rr => {
      if (+rr[0] !== 99) {
        const bet = createBet('round_robin', 0, rr[1], 1, useFreePlay, 0, rr[0], true);
        bet.selections = straightSelections;
        tmpBets.push(bet);
      } else {
        const subType = availableTypes
          .filter(t => +t.parlay_size !== 99)
          .map(r => r.parlay_size)
          .join(',');
        const bet = createBet('round_robin', 0, rr[1], 1, useFreePlay, 0, subType, true);
        bet.selections = straightSelections;
        tmpBets.push(bet);
      }
    });

    return tmpBets;
  }

  // for (let bet of betOption.Selections) {
  //   const betType = selectedType || 'straight';
  //   if (bet.input_risk_amount > 0 || sendZeros) {
  //     if (filter.indexOf(betType) > -1) {
  //       if (betType === 'straight') {
  //         const selection = getStraightUniqueBet(selections, bet.OutComeId);
  //         if (!selection) continue;
  //         bet.type = 'straight';

  //         selection.checked = true;
  //         bet.selections = [selection];
  //         tmpBets.push(bet);
  //       } else {
  //         if (isGetBetOptions) {
  //           bet.selections = selections.map(s => ({ ...s, checked: isChecked(s.id) })).toJSON();
  //         } else {
  //           //bet.selections = selections.filter(s => isChecked(s.id)).toJSON();
  //           bet.selections = selections.toJSON();
  //         }

  //         if (['parlay', 'teaser', 'round_robin'].includes(betType) && selectedType === 'straight') {
  //           let gameIds = bet.selections.map(item => item.dgs_game_id);
  //           let isDuplicate = gameIds.some((item, idx) => gameIds.indexOf(item) != idx);
  //           if (betType === 'round_robin' && !bet.sub_type) {
  //             bet.input_risk_amount = 0;
  //           }
  //           if (!isDuplicate) {
  //             tmpBets.push(bet);
  //           }
  //         } else {
  //           tmpBets.push(bet);
  //         }
  //       }
  //     }
  //   }
  // }
  console.log('[BETSLIP] buildBets result', state.betOptionsResponse);
  return state.betOptionsResponse;
}

function getStraightUniqueBet(selections, id) {
  for (let selection of selections) {
    if (selection.id == id) {
      return selection;
    }
  }
}

export function getBetIndex(bets, type, bet_id, sub_type) {
  let i = 0;
  for (let bet of bets) {
    if (type == 'straight') {
      if (bet.betid == bet_id) {
        return i;
      }
    } else if (
      type == bet.type ||
      (type == 'if_win' && bet.type == 'if_win_or_tie') ||
      (type == 'if_win_or_tie' && bet.type == 'if_win')
    ) {
      return i;
    }
    i++;
  }

  return false;
}

export function getSelectionIndex(selections, selection_id) {
  for (let selection of selections) {
    if (selection.Id === selection_id) {
      return selection;
    }
  }
  return null;
}

export function getSelectedPointObjectFromBetOptions(betOptionsResponse, selection_identifier, points, selectedType) {
  var selections = betOptionsResponse.Selections.map(m => m);

  for (let i = 0; i < selections.length; i++) {
    const betOption = selections[i];
    const line_selections = betOption;
    if (line_selections && line_selections.OutComeId === selection_identifier) {
      return line_selections.AvailableBuyPoints.filter(opt => opt.Point == points)[0];
    }
  }
  return null;
}

export function getSelectedTeaserObjectFromBetOptions(betOptionsResponse, wager_type_id, returnFirstIfNotFound) {
  let option = null;
  const betOption = betOptionsResponse;
  if (betOption.AvailableTeaserPoints) {
    option = find(betOption.AvailableTeaserPoints, opt => opt.IdWagerType == wager_type_id);
  }

  if (returnFirstIfNotFound && option == null) {
    if (betOption.AvailableTeaserPoints) {
      const firstKey = betOption.AvailableTeaserPoints[0];
      return firstKey.IdWagerType;
    }
  }

  return option;
}

export function removeRotationNumberFromSelection(selection, text) {
  if (selection.MarketType == 'sp') {
    if (!selection.Point || selection.Point == 0) {
      text = text.replace('(0)', '(PK)');
    }
  }
  return text ? text.replace(/\[[^\]]*\]/, '') : '';
}

export function persistBets(bets) {
  if (!bets || bets.size === 0) {
    return localStorage.removeItem(BETS_STORAGE_KEY);
  }
  localStorage.setItem(BETS_STORAGE_KEY, JSON.stringify(minimizeBets(bets)));
}

function minimizeBets(bets) {
  var _min_bet = [];
  for (let i = 0; i < bets.size; i++) {
    var b = bets.get(i);
    var min_bet = {
      id: b.betid,
      t: b.type,
      r: b.input_risk_amount,
      w: b.input_win_amount,
      f: b.use_free_play,
      o: b.open_spots,
      s: b.sub_type,
      c: b.checked,
    };
    _min_bet.push(min_bet);
  }
  return _min_bet;
}

export function restoreBets() {
  var bets = [];
  var min_bets = localStorage.getItem(BETS_STORAGE_KEY);
  if (min_bets) {
    min_bets = JSON.parse(min_bets);
    for (let i = 0; i < min_bets.length; i++) {
      var new_bet = {
        betid: min_bets[i].id,
        type: min_bets[i].t,
        input_risk_amount: min_bets[i].r,
        input_win_amount: min_bets[i].w,
        use_free_play: min_bets[i].f,
        open_spots: min_bets[i].o,
        sub_type: min_bets[i].s,
        checked: min_bets[i].c,
      };

      bets.push(new_bet);
    }
  }
  return bets;
}

function minimizeSelections(selections) {
  return selections;
}

export function persistSelections(selections) {
  if (!selections) return localStorage.removeItem(SELECTIONS_STORAGE_KEY);
  localStorage.setItem(SELECTIONS_STORAGE_KEY, JSON.stringify(minimizeSelections(selections)));
  Cookies.remove(SELECTIONS_STORAGE_KEY);
}

export function persistNewSelections(selections) {
  if (!selections) return localStorage.removeItem(SELECTIONS_NEW_STORAGE_KEY);
  localStorage.setItem(SELECTIONS_NEW_STORAGE_KEY, JSON.stringify(minimizeSelections(selections)));
  Cookies.remove(SELECTIONS_NEW_STORAGE_KEY);
}

export function persistBetSlip(betslip) {
  if (!betslip) return localStorage.removeItem(SELECTIONS_NEW_BETSLIP_KEY);
  localStorage.setItem(SELECTIONS_NEW_BETSLIP_KEY, JSON.stringify(minimizeSelections(betslip)));
  Cookies.remove(SELECTIONS_NEW_BETSLIP_KEY);
}

export function restoreSelections() {
  let selections = localStorage.getItem(SELECTIONS_STORAGE_KEY)
    ? JSON.parse(localStorage.getItem(SELECTIONS_STORAGE_KEY))
    : [];
  return selections.map(i => {
    return {
      id: i.id,
      dgs_game_id: i.dg,
      dgs_participant_id: i.dp,
      dgs_sport_id: i.ds,
      line: i.l,
      spread: i.s,
      odds: i.o,
      new_spread: i.ns,
      points: i.p,
    };
  });
}

export function restoreNewSelections() {
  let selections = localStorage.getItem(SELECTIONS_NEW_STORAGE_KEY)
    ? JSON.parse(localStorage.getItem(SELECTIONS_NEW_STORAGE_KEY))
    : [];
  return selections;
}

export function restoreBetSlip() {
  let selections = localStorage.getItem(SELECTIONS_NEW_BETSLIP_KEY)
    ? JSON.parse(localStorage.getItem(SELECTIONS_NEW_BETSLIP_KEY))
    : null;
  return selections;
}

export function persistRoundRobinTab(roundRobinTab) {
  localStorage.setItem(ROUND_ROBIN_STORAGE_KEY, JSON.stringify(roundRobinTab));
  Cookies.remove(ROUND_ROBIN_STORAGE_KEY);
}

export function restoreRoundRobinTab() {
  return localStorage.getItem(ROUND_ROBIN_STORAGE_KEY)
    ? JSON.parse(window.localStorage.getItem(ROUND_ROBIN_STORAGE_KEY))
    : defaultRoundRobinTabContext;
}

export function persistGameDetails(gameDetails) {
  localStorage.setItem(GAME_DETAILS_STORAGE_KEY, JSON.stringify(gameDetails));
}

export function restoreGameDetails() {
  return localStorage.getItem(GAME_DETAILS_STORAGE_KEY)
    ? JSON.parse(window.localStorage.getItem(GAME_DETAILS_STORAGE_KEY))
    : {};
}

export function clearBetsAndSelectionsFromStorage(
  bets,
  lineSelections,
  gameDetails,
  checkedSelections,
  liveSelections,
) {
  persistNewSelections(lineSelections);
  persistBetSlip(bets);
  persistGameDetails(gameDetails);
  persistCheckedIds(checkedSelections);
  persistLiveIds(liveSelections);
  persistRoundRobinTab(defaultRoundRobinTabContext);
}

export function convertOdds(odd_value, odd_type) {
  if (!odd_value) return '0';
  let toReturn;
  switch (odd_type) {
    case 'E':
      // add '+' in front of odd if not exists
      if (odd_value && parseFloat(odd_value) > 0) {
        odd_value = '+' + parseFloat(odd_value);
      }
      toReturn = odd_value;
      break;

    case 'D':
      toReturn = decimalFromUS(odd_value).toFixed(2);
      break;

    case 'F':
      if (odd_value == -112) return '25/28';
      if (odd_value == -120) return '5/6';
      if (odd_value == -125) return '4/5';
      if (odd_value == -130) return '10/13';
      if (odd_value == -130) return '10/13';
      if (odd_value == -135) return '20/27';
      if (odd_value == -140) return '5/7';
      if (odd_value == -145) return '20/29';
      if (odd_value == -150) return '2/3';
      if (odd_value == -155) return '20/31';
      if (odd_value == -150) return '2/3';
      if (odd_value == -160) return '5/8';
      if (odd_value == -165) return '20/33';
      if (odd_value == -170) return '10/17';
      if (odd_value == -175) return '4/7';
      if (odd_value == -180) return '5/9';
      if (odd_value == -185) return '20/37';
      if (odd_value == -190) return '10/19';
      if (odd_value == -195) return '20/39';
      if (odd_value == -215) return '20/43';
      if (odd_value == -220) return '5/11';
      if (odd_value == -225) return '4/9';
      if (odd_value == -230) return '10/23';
      if (odd_value == -235) return '20/47';
      if (odd_value == -240) return '5/12';
      if (odd_value == -245) return '71/174';
      //toReturn = fractionalFromDecimal( (odd_value));
      toReturn = MCD(Math.abs(odd_value), 100);
      toReturn = visualize(toReturn, odd_value);
      break;
  }
  return toReturn;
}

export function parlaycalculationodd(selections, maxpayoutodd) {
  let cont = 1;
  for (let i = 0; i < selections.length; i++) {
    if (selections[i].Odd < 0) {
      cont = cont * (Math.abs(100 / selections[i].Odd) + 1);
    } else {
      cont = cont * (Math.abs(selections[i].Odd / 100) + 1);
    }
  }
  cont = cont - 1;
  cont = cont * 100;

  if (cont > maxpayoutodd && maxpayoutodd > 0) cont = maxpayoutodd;

  return cont;
}

export function parlayNewCalculationOdds(selections, maxpayoutodd) {
  let cont = 1;

  for (let i = 0; i < selections.length; i++) {
    let decimalOdd = roundAmount(americanToDecimal(selections[i].Odd));

    cont = cont * decimalOdd
  }

  cont = cont.toFixed(2);

  if (cont >= 2) {
    cont = (cont - 1) *100;
  } else {
    cont = -100 / ( cont - 1);
  }

  if (cont > maxpayoutodd && maxpayoutodd > 0) cont = maxpayoutodd;

   return cont.toFixed(0);
}

//Steal from MYB
function fracTable(us) {
  //positive odds
  if (us == 100) {
    return '10/1';
  }
  if (us == 105) {
    return '21/20';
  }
  if (us == 110) {
    return '11/10';
  }
  if (us == 120) {
    return '6/5';
  }
  if (us == 125) {
    return '5/4';
  }
  if (us == 130) {
    return '13/10';
  }
  if (us == 137) {
    return '11/8';
  }
  if (us == 140) {
    return '7/5';
  }
  if (us == 150) {
    return '6/4';
  }
  if (us == 160) {
    return '8/5';
  }
  if (us == 162) {
    return '13/8';
  }
  if (us == 170) {
    return '17/10';
  }
  if (us == 175) {
    return '7/4';
  }
  if (us == 180) {
    return '9/5';
  }
  if (us == 187) {
    return '15/8';
  }
  if (us == 190) {
    return '19/10';
  }
  if (us == 200) {
    return '2/1';
  }
  if (us == 210) {
    return '21/10';
  }
  if (us == 212) {
    return '85/40';
  }
  if (us == 220) {
    return '11/5';
  }
  if (us == 225) {
    return '9/4';
  }
  if (us == 230) {
    return '23/10';
  }
  if (us == 237) {
    return '95/40';
  }
  if (us == 240) {
    return '12/5';
  }
  if (us == 250) {
    return '5/2';
  }
  if (us == 260) {
    return '13/5';
  }
  if (us == 275) {
    return '11/4';
  }
  if (us == 280) {
    return '14/5';
  }
  if (us == 300) {
    return '3/1';
  }
  if (us == 320) {
    return '16/5';
  }
  if (us == 350) {
    return '7/2';
  }
  if (us == 360) {
    return '18/5';
  }
  if (us == 400) {
    return '4/1';
  }
  if (us == 450) {
    return '9/2';
  }
  if (us == 500) {
    return '5/1';
  }
  if (us == 550) {
    return '11/2';
  }
  if (us == 600) {
    return '6/1';
  }
  if (us == 650) {
    return '13/2';
  }
  if (us == 700) {
    return '7/1';
  }
  if (us == 750) {
    return '15/2';
  }
  if (us == 800) {
    return '8/1';
  }
  if (us == 850) {
    return '17/2';
  }
  if (us == 900) {
    return '9/1';
  }
  //Negative odds
  if (us == -100) {
    return '1/1';
  }
  if (us == -105) {
    return '20/21';
  }
  if (us == -110) {
    return '10/11';
  }
  if (us == -111) {
    return '9/10';
  }
  if (us == -112) {
    return '25/28';
  }
  if (us == -115) {
    return '20/23';
  }
  if (us == -120) {
    return '5/6';
  }
  if (us == -125) {
    return '4/5';
  }
  if (us == -130) {
    return '10/13';
  }
  if (us == -135) {
    return '20/27';
  }
  if (us == -137) {
    return '8/11';
  }
  if (us == -140) {
    return '5/7';
  }
  if (us == -142) {
    return '7/10';
  }
  if (us == -145) {
    return '20/29';
  }
  if (us == -150) {
    return '2/3';
  }
  if (us == -155) {
    return '20/31';
  }
  if (us == -160) {
    return '5/8';
  }
  if (us == -162) {
    return '8/13';
  }
  if (us == -165) {
    return '20/33';
  }
  if (us == -166) {
    return '3/5';
  }
  if (us == -170) {
    return '10/17';
  }
  if (us == -175) {
    return '4/7';
  }
  if (us == -180) {
    return '5/9';
  }
  if (us == -185) {
    return '20/37';
  }
  if (us == -187) {
    return '8/15';
  }
  if (us == -190) {
    return '10/19';
  }
  if (us == -195) {
    return '20/39';
  }
  if (us == -200) {
    return '1/2';
  }
  if (us == -212) {
    return '40/85';
  }
  if (us == -215) {
    return '20/43';
  }
  if (us == -220) {
    return '5/11';
  }
  if (us == -222) {
    return '9/20';
  }
  if (us == -225) {
    return '4/9';
  }
  if (us == -230) {
    return '10/23';
  }
  if (us == -235) {
    return '20/47';
  }
  if (us == -240) {
    return '5/12';
  }
  if (us == -245) {
    return '71/174';
  }
  if (us == -250) {
    return '2/5';
  }
  if (us == -275) {
    return '4/11';
  }
  if (us == -285) {
    return '7/20';
  }
  if (us == -300) {
    return '1/3';
  }
  if (us == -350) {
    return '2/7';
  }
  if (us == -400) {
    return '1/4';
  }
  if (us == -450) {
    return '2/9';
  }
  if (us == -500) {
    return '1/5';
  }

  return 0;
}

export function fractionFromUS(us) {
  let table = fracTable(us);

  if (table) return table;

  let decimal;

  if (us > 0) decimal = us / 100 + 1;
  else decimal = (100 / us) * -1 + 1;

  decimal = Math.round(decimal * 100) / 100;

  return fractionalFromDecimal(decimal);
}

/**
 * We changed it to make fractional odds sync with proxy calculation.
 * @param a
 * @param b
 * @returns {number | number}
 * @constructor
 */
function MCD(a, b) {
  let num2 = 0;
  let num3 = 0;
  if (b > a) {
    b = a;
    a = num3;
  }
  a = Math.abs(a);

  for (b = Math.abs(b); b != 0; b = num2) {
    num2 = a % b;
    a = b;
  }

  return a;
}

function visualize(toReturn, odd_value) {
  if (!(parseFloat(odd_value) > 0)) {
    toReturn = `${100 / toReturn}/${Math.abs(odd_value / toReturn)}`;
  } else {
    toReturn = `${odd_value / toReturn}/${100 / toReturn}`;
  }

  return toReturn;
}

function fractionalFromDecimal(decimal) {
  decimal = parseFloat(decimal).toFixed(2);
  var num = (decimal - 1) * 10000;
  var dom = 10000;

  num = Math.round(num);
  dom = Math.round(dom);

  var a = reduce(num, dom);
  num = a[0];
  dom = a[1];

  return num + '/' + dom;
}

export function oddToMoneyline(odd) {
  if (odd == 0) {
    return 'EV';
  }

  if (odd > 0) {
    return '+' + parseInt(odd);
  }

  return odd;
}

function reduce(a, b) {
  var n = new Array(2);
  var f = GCD(a, b);
  n[0] = a / f;
  n[1] = b / f;
  return n;
}

function GCD(num1, num2) {
  var a;
  var b;
  if (num1 < num2) {
    a = num2;
    b = num1;
  } else if (num1 > num2) {
    a = num1;
    b = num2;
  } else if (num1 == num2) {
    return num1;
  }
  while (1) {
    if (b == 0) {
      return a;
    } else {
      var temp = b;
      b = a % b;
      a = temp;
    }
  }
}

export function parseBetErrorMessage(error, currencySymbol) {
  const messageCode = error.ErrorMessageKey;
  const errorCode = error.ErrorMessageKey ? ' ' + error.ErrorMessageKey : '';
  const message = error.ErrorMessage;
  const key = 'BetSlip.Errors.' + messageCode;
  let args = error.ErrorMessageParams ? error.ErrorMessageParams.split('-,-') : [];
  if (messageCode === 'EXCEEDPARLAY') {
    if (args[0].includes('R')) {
      args[0] = args[0].replace('R', '');
    }
    // if (store.state.settings.selectedOddType === "D") {
    //   let maxOdd = parseInt(args[0])
    //   args[0] = americanToDecimal(maxOdd).toString()
    // }
    // else if (store.state.settings.selectedOddType === "F") {
    //   let maxOdd = parseInt(args[0])
    //   args[0] = fractionalFromDecimal(decimalFromUS(maxOdd))
    // }
  }

  const originArgs = args;
  args = args.map(item => i18n.t(item.toUpperCase()));
  const exists = i18n.t(key, args);

  const multipleParamErrorCodes = [
    'FREEPLAYMAXTEAMEXCEED',
    'FREEPLAYMAXFAVEXCEED',
    'MAXPARLAYRISKEXCEED',
    'FREEPLAYPAYEXCEED',
  ];

  if (messageCode === 'FREEPLAYMAXTEAMEXCEED') {
    return i18n.t('BetSlip.Errors.FREEPLAYMAXTEAMEXCEED', [args]);
  }

  if (messageCode === 'FREEPLAYPAYEXCEED ') {
    return i18n.t('BetSlip.Errors.FREEPLAYPAYEXCEED', [args]);
  }

  if (messageCode === 'INVSELWAGERTYPE') {
    const typeMap = {
      PARLAY: 'parlay',
      'If Win': 'if_win',
      'Reverse Win': 'reverse',
    };
    return i18n.t('BetSlip.Errors.INVSELWAGERTYPE', [originArgs[0], getTranslatedBetType(typeMap[originArgs[1]])]);
  }

  if (messageCode === 'NOIFBET') {
    if (args.length > 0) {
      args[0] = args[0].replace(/~~/g, ' ');
    }
    return i18n.t('BetSlip.Errors.NOIFBET', [args]);
  }

  if (multipleParamErrorCodes.includes(messageCode)) {
    return exists ? i18n.t(key, args) : message || messageCode;
  }

  if (currencySymbol) {
    args = [currencySymbol + args];
    return exists ? i18n.t(key, args) : message || messageCode;
  } else {
    return exists ? i18n.t(key, args) : message || messageCode;
  }
}

export function normalizeSpread(line, spread) {
  if (line === 'to') {
    if (parseFloat(spread) < 0) {
      return '' + spread.replace('-', '');
    } else {
      return '' + spread;
    }
  }
  else if (line === 'sp' && (spread == '0.0' || spread == '0')) return 'PK';
  else if (line === 'sp' && parseFloat(spread) > 0) return '+' + parseFloat(spread);
  else if (line === 'sp' && parseFloat(spread) < 0) return parseFloat(spread);
  return '';
}

export function getTranslatedBetType(type) {
  if (type === 'straight') return i18n.t('BetSlip.Straight');
  if (type === 'parlay') return i18n.t('BetSlip.Parlay');
  if (type === 'round_robin') return i18n.t('BetSlip.RR Long');
  if (type === 'if_bet') return i18n.t('BetSlip.If Bet');
  if (type === 'if_win') return i18n.t('BetSlip.If Win');
  if (type === 'if_win_or_tie') return i18n.t('BetSlip.If Win Or Tie');
  if (type === 'reverse') return i18n.t('BetSlip.Reverse');
  if (type === 'teaser') return i18n.t('BetSlip.Teaser');
}

export function getRoundRobinCombinations(bets, size) {
  Array.prototype.combinations = function (n) {
    return this.reduce(
      (p, c, i, a) =>
        p.concat(
          n > 1
            ? a
              .slice(i + 1)
              .combinations(n - 1)
              .map(e => [].concat(e, c))
            : [[c]],
        ),
      [],
    );
  };

  return bets.combinations(size);
}

export function getWinAmount(bet, inputRisk) {
  if (
    bet.some(item => {
      return roundAmount(americanToDecimal(item.Odd)) != '1.91';
    })
  ) {
    return (
      inputRisk *
      bet.reduce((acc, value) => {
        return acc * americanToDecimal(value.Odd);
      }, 1) -
      inputRisk
    ).toFixed(2);
  } else {
    let total = 0;
    switch (bet.length) {
      case 2:
        total = 2.6;
        break;
      case 3:
        total = 6;
        break;
      case 4:
        total = 12;
        break;
      case 5:
        total = 24;
        break;
      case 6:
        total = 47;
        break;
      case 7:
        total = 91;
        break;
      case 8:
        total = 175;
        break;
      case 9:
        total = 300;
        break;
      case 10:
        total = 600;
        break;
      default:
        return 0;
    }

    return inputRisk * total;
  }
}

export function getWinAmountRR(bet) {
  let inputRisk = bet.input_risk_amount;
  let combs = getRoundRobinCombinations(bet.Selections, bet.RoundRobinCombinations);
  let totalWin = 0;
  combs.forEach(f => {
    if (
      f.some(item => {
        return roundAmount(americanToDecimal(item.Odd)) != '1.91';
      })
    ) {
      totalWin +=
        inputRisk *
        f.reduce((acc, value) => {
          return acc * americanToDecimal(value.Odd);
        }, 1) -
        inputRisk;
    } else {
      let total = 0;
      switch (f.length) {
        case 2:
          total = 2.6;
          break;
        case 3:
          total = 6;
          break;
        case 4:
          total = 12;
          break;
        case 5:
          total = 24;
          break;
        case 6:
          total = 47;
          break;
        case 7:
          total = 91;
          break;
        case 8:
          total = 175;
          break;
        case 9:
          total = 300;
          break;
        case 10:
          total = 600;
          break;
        default:
          return 0;
      }

      totalWin += inputRisk * total;
    }
  });
  return totalWin.toFixed(2);
}

export function checkSpreadPk(selection, desc) {
  if (selection.MarketType == 'sp') {
    if (!selection.Point || selection.Point == 0) {
      desc = desc.replace('(0)', '(PK)');
    }
  }
  return desc;
}
